module.exports = __webpack_public_path__ + "img/side_car_1.f4b35890.jpg";